Ext.define('SA.view.NotificationsMenuItem', {
    alias: 'widget.notifications-menu-item',
    extend: 'Ext.Component',

    autoEl: 'button',
    cls: 'sa-notifications-menu-item',
    overCls: 'sa-notifications-menu-item-hover',

    tpl: [
        '<div class="sa-notifications-menu-item-icon-container">',
            '<svg class="sa-notifications-menu-item-icon-svg"><use href="#sa-icon-map-info"></use></svg>',
        '</div>',
        '<div class="sa-notifications-menu-item-date-and-title-container">',
            '<div class="sa-notifications-menu-item-title">{titleText:htmlEncode}</div>',
            '<div class="sa-notifications-menu-item-date">{date:date("F j")}</div>',
        '</div>',
    ],

    initComponent() {
        this.addCls(this.data.didRead ? 'sa-notifications-menu-item-read' : 'sa-notifications-menu-item-unread');

        this.callParent();
    }
});